import { datadogRum } from '@datadog/browser-rum'

export function createDatadogGuard(router) {
  router.beforeEach(async (to) => {
    datadogRum.startView({
      name: to.meta.code,
      service: to.meta.title,
      version: '1'
    })
  })
}
